/**
 * 调用唤端
 */
/**
 * 通过window.location.href唤端
 * @param url
 */
export function evokeByLocation(url) {
  window.location.href = url;
}
/**
 * 通过a标签唤端
 * @param url
 */
export function evokeByTagA(url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.style.display = 'none';
  document.body.appendChild(a);
  var e = document.createEvent('HTMLEvents');
  e.initEvent('click', false, false);
  a.dispatchEvent(e);
}
/**
 * 创建iframe
 * 先创建好iframe对象
 */
var iframe;
export function buildIFrame() {
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = "callapp_iframe_".concat(Date.now());
    iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
    document.body.appendChild(iframe);
  }
}
/**
 * 通过iframe唤端
 * @param url
 */
export function evokeByIFrame(url) {
  iframe.src = url;
}